import { render, staticRenderFns } from "./autoCompleteBusca.vue?vue&type=template&id=3e7d9efa&"
import script from "./autoCompleteBusca.vue?vue&type=script&lang=js&"
export * from "./autoCompleteBusca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports